import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';  // ← added this import

function AcceptedBreeds() {
  const [breeds, setBreeds] = useState([]);
  const [groupFilter, setGroupFilter] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetch(`${API_BASE_URL}/breeds`)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
        return res.text(); // Get raw text first
      })
      .then(text => {
        console.log('Raw response:', text);
        try {
          const data = JSON.parse(text);
          setBreeds(data);
        } catch (err) {
          setMessage('Failed to parse breeds: ' + err.message);
        }
      })
      .catch(err => setMessage('Failed to load breeds: ' + err.message));
  }, []);

  const uniqueGroups = [...new Set(breeds.map(b => b.breedGroup))].sort();
  const filteredBreeds = groupFilter
    ? breeds.filter(b => b.breedGroup === groupFilter).sort((a, b) => a.breedName.localeCompare(b.breedName))
    : breeds.sort((a, b) => a.breedName.localeCompare(b.breedName));

  const groupedBreeds = groupFilter
    ? { [groupFilter]: filteredBreeds }
    : breeds.reduce((acc, breed) => {
        acc[breed.breedGroup] = acc[breed.breedGroup] || [];
        acc[breed.breedGroup].push(breed);
        return acc;
      }, {});

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', padding: '20px' }}>
      <h1 style={{ color: '#1E88E5', marginBottom: '20px' }}>Accepted Breeds</h1>

      {message && (
        <div
          style={{
            backgroundColor: '#BBDEFB',
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '5px',
            color: '#333',
            fontWeight: 'bold'
          }}
        >
          {message}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        <label style={{ marginRight: '10px', fontWeight: 'bold', color: '#333' }}>
          Filter by Breed Group:
        </label>
        <select
          value={groupFilter}
          onChange={(e) => setGroupFilter(e.target.value)}
          style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc' }}
        >
          <option value="">All Groups (Alphabetical)</option>
          {uniqueGroups.map(group => (
            <option key={group} value={group}>
              {group}
            </option>
          ))}
        </select>
      </div>

      {Object.keys(groupedBreeds).length > 0 ? (
        Object.keys(groupedBreeds)
          .sort()
          .map(group => (
            <div key={group} style={{ marginBottom: '40px' }}>
              {groupFilter === '' && (
                <h2 style={{ color: '#1E88E5', marginBottom: '20px' }}>{group}</h2>
              )}

              <div
                style={{
                  backgroundColor: '#f9f9f9',
                  padding: '20px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                  border: '1px solid #BBDEFB'
                }}
              >
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                  {groupedBreeds[group].map(breed => (
                    <Link
                      key={breed._id}
                      to={`/breeds/${breed.breedCode}`}           // ← this creates the link
                      style={{ textDecoration: 'none', color: 'inherit' }}  // no blue underline
                    >
                      <div
                        style={{
                          textAlign: 'center',
                          width: '200px',
                          padding: '10px',
                          backgroundColor: '#fff',
                          borderRadius: '5px',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                          transition: 'transform 0.2s',
                          cursor: 'pointer'                        // hand cursor on hover
                        }}
                        onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                      >
                        <img
                          src={breed.defaultArtUrl || 'https://via.placeholder.com/150'}
                          alt={breed.breedName}
                          style={{
                            maxWidth: '150px',
                            height: '150px',
                            objectFit: 'cover',
                            borderRadius: '8px'
                          }}
                        />
                        <p
                          style={{
                            margin: '10px 0',
                            fontSize: '16px',
                            color: '#333',
                            fontWeight: 'bold'
                          }}
                        >
                          {breed.breedName}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))
      ) : (
        <p style={{ color: '#888', fontSize: '16px' }}>No breeds available.</p>
      )}
    </div>
  );
}

export default AcceptedBreeds;